// extracted by mini-css-extract-plugin
module.exports = {"root":"Toggle_root__2P1hx","item":"Toggle_item__2kdry","icon":"Toggle_icon__3UNLx","typography":"Toggle_typography__dGUn0"};